import React from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`

const ErrorText = styled.span`
    font-size: 11px;
    height: 16px;
    color: ${props => props.theme.colors.error}
`

export const inputStyle = css`
    border: 1px solid ${props => props.theme.colors.lightGrey};
    border-radius: 5px;
    width: 100%;

    font-style: italic;
    font-size: 13px;
    font-weight: 300;
    letter-spacing: -0.05em;
    padding-left: 5px;
    color: ${props => props.theme.colors.textPrimary};

    &::placeholder {
        color: ${props => props.theme.colors.textPrimary};
    }

    ${props => props.error && `
        border-color: ${props.theme.colors.error}
    `}
`



export const StyledInput = styled.input`
    ${inputStyle}
    height: 33px;
`
export const StyledTextarea = styled.textarea`
    ${inputStyle}
`

export const Input = (props) => {

    const handleChange = (e) => {
        const value = e.target.value;
        if (props.onChange) {
            props.onChange(value)
        }
    }

    const handleChangeNumber = (e) => {
        const value = e.target.value.replace(/[^\d\s-/]/g, "");
        if (props.onChange) {
            props.onChange(value)
        }
    }

    if (props.inputType === 'number') {
        return (
            <Wrapper>
                <StyledInput {...props} onChange={handleChangeNumber} />
                <ErrorText>{props.error || ""}</ErrorText>
            </Wrapper>
        )
    }

    if (props.multi) {
        return (
            <Wrapper>
                <StyledTextarea {...props} onChange={handleChange} />
                <ErrorText>{props.error || ""}</ErrorText>
            </Wrapper>
        )
    }

    return (
        <Wrapper>
            <StyledInput {...props} onChange={handleChange} />
            <ErrorText>{props.error || ""}</ErrorText>
        </Wrapper>
    )
}
